module.exports = __webpack_public_path__ + "img/deleteCasino.77f68c02.jpg";